import UserProfile from "../../components/profile/UserProfile.jsx";
import { useState, useEffect } from "react";
import "./profileList.scss";
export default function ProfileList() {
  return (
    <>
      <UserProfile />
    </>
  );
}
